var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"mask-center"},[_c('el-button',{staticClass:"font48 el-icon-loading",attrs:{"type":"text"}}),_c('el-button',{staticClass:"font30",attrs:{"type":"text"}},[_vm._v("登录中, 请稍后...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }